import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

import config from 'lib/config'

Bugsnag?.start({
  apiKey: config.BUGSNAG_API_KEY,
  appVersion: window?.globals?.version || 'v3.15.9',
  plugins: [new BugsnagPluginReact()],
  releaseStage: config.ENV,
})

export const BugsnagErrorBoundary =
  Bugsnag.getPlugin('react').createErrorBoundary(React)
